import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import $ from "jquery";
import { loader_image } from "../_components/Imagepath";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {base_url, Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Select from "react-select";

import AddNewDriverPayment from '../rawmaterialsoldestansports/AddNewDriverPayment';

const SoldesTransports = () => {
  const [menu, setMenu] = useState(false);
  // const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [datacount, setDatacount] = useState({});
  const [permission, setPermission] = useState({});

  const [trasnportList, setTrasnportList] = useState([]);
  const [paymentslists, setPaymentslists] = useState([]);
       let season_id = localStorage.getItem("season_id");

    
        const [formData, setFormData] = useState({
          season_id: season_id,
          start_date: '',
          end_date: '',
          name: ''
        });
      

  // useEffect(() => {
  //       setPermission(FindModuleById(438)); 
  //     console.log(permission);
  //   axios.post(
  //       "/raw-materials/listing-transports-new",
  //       formData,
  //       {
  //         headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //       }
  //     )
  //     .then((response) => {
  //       setDatacount(response.data.data.overview);
  //       setDataa(response.data.data.transports);
  //       setPaymentslists(response.data.data.payments);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  
  //   axios.post("/rawmaterials-transports/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`,  Apitoken: Apitoken,},  } )
  //   .then((response) => {
  //     if (response.data.code === 200) {
  //       let suppliers = response.data.data.transports;
  //       let supplierslist = suppliers.map((cat, index) => ({
  //         // label: cat.driver_name + ' ('+cat.plate_number+')' ,
  //         label: `${cat.driver_name} (${cat.plate_number && cat.plate_number !== 'null' ? cat.plate_number : ''})`,
  //         value: cat.id,
  //         text: `transport-${index}`,
  //       }));
  //       setTrasnportList(supplierslist);
  //     } else {
  //       console.log("API response is not an array");
  //     }
  //   })  .catch((error) => {
  //     console.log(error);
  //   });
  // }, []);
  const fetchTransportsData = useCallback(() => {
    axios.post(
        "/raw-materials/listing-transports-new",
        formData,
        {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
    )
    .then((response) => {
        setDatacount(response.data.data.overview);
        setDataa(response.data.data.transports);
        setPaymentslists(response.data.data.payments);
    })
    .catch((error) => {
        console.log(error);
    });
}, [formData]);

const fetchTransportList = useCallback(() => {
    axios.post("/rawmaterials-transports/listing", {}, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
        if (response.data.code === 200) {
            let suppliers = response.data.data.transports;
            let supplierslist = suppliers.map((cat, index) => ({
                label: `${cat.driver_name} (${cat.plate_number && cat.plate_number !== 'null' ? cat.plate_number : ''})`,
                value: cat.id,
                text: `transport-${index}`,
            }));
            setTrasnportList(supplierslist);
        } else {
            console.log("API response is not an array");
        }
    })
    .catch((error) => {
        console.log(error);
    });
}, []);

useEffect(() => {
    setPermission(FindModuleById(438));

    // Initial fetch
    fetchTransportsData();
    fetchTransportList();

    // Refetch when tab becomes visible again
    const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
            fetchTransportsData();
        }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup
    return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
}, [fetchTransportsData, fetchTransportList]);


  const handleSelectChangeCustomer = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, name: selectedOption.value }); 
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  

  const DriverCell = ({ row }) => (
    <a href={`/transport-situation-groupby/${row.original.driver_id}`} className="">
      {row.original.driver_name || ""}
    </a>
  );
  
  DriverCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        driver_id: PropTypes.number,
        driver_name: PropTypes.string,
      }),
    }),
  };
  
  const TotalAmountCell = ({ row }) => (
  <div>{Number(row.original.sum_final_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} dh</div>

  );
  
  TotalAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_final_amount: PropTypes.number,
      }),
    }),
  };
  
  const PaidAmountCell = ({ row }) => (
  <div>{Number(row.original.sum_final_payment_1_2).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} dh</div>
  );
  
  PaidAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        sum_final_payment_1_2: PropTypes.number,
      }),
    }),
  };
  
  const OpenAmountCell = ({ row }) => (
  <div>{Number(row.original.situation).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} dh</div>
  );
  
  OpenAmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        situation: PropTypes.number,
      }),
    }),
  };
  
  const columnss = [
    {
      header: 'Driver',
      accessorKey: 'driver_name',
      Cell: DriverCell,
    },
    {
      accessorKey: 'plate_number',
      header: 'Plate Number',
    },
    {
      accessorKey: 'number_of_receiption',
      header: 'No of Receiption',
    },
   
     {
    header: 'Total Amount',
    accessorKey: 'sum_final_amount', // Changed from accessorFn
    Cell: TotalAmountCell,
  },
  {
    header: 'Paid Amount',
    accessorKey: 'sum_final_payment_1_2', // Changed from accessorFn
    Cell: PaidAmountCell,
  },
  {
    header: 'Open Amount',
    accessorKey: 'situation', // Changed from accessorFn
    Cell: OpenAmountCell,
  },
  ];    
  


   const columnspayments =
   [
  
    {
      header: 'Driver',
      accessorFn: (row) => `${(row.transportname)?row.transportname.driver_name:""} `,
    },
    {
      header: 'Plate Number',
      accessorFn: (row) => `${(row.transportname)?row.transportname.plate_number:""} `,
    },
 
 
 
    {
      accessorKey: 'lot_number', //normal accessorKey
      header: 'Lot Number',
    },
 
 
    {
      accessorKey: 'shift_date', //normal accessorKey
      header: 'Shift Date',
    },
 
    {
      accessorKey: 'transport_cost', //normal accessorKey
      header: 'Transport Cost',
    },
    
   
     {
       accessorKey: 'origin', //normal accessorKey
       header: 'Origin',
     },
  
     {
      header: 'Supplier',
      accessorFn: (row) => `${(row.supplier_name)?row.supplier_name.name:""} `,
    },
    ];
 
 


  
    const downloadPDF = (e) => {
      console.log(e);
      $("#loader-image").removeClass('loader-hide').addClass('loader-show');
  
      axios.get("/raw-materials/listing-transports-pdf", {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          params: formData, // Use `params` for GET request data
      })
      .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          let file_name = 'Transport Situation '+datacount.start_date +' '+ datacount.end_date+ '.pdf';
          //let fileName = file_name;
          link.download = file_name;

          link.click();
          
          $("#loader-image").removeClass('loader-show').addClass('loader-hide');
      })
      .catch(error => {
          console.error('Error downloading PDF:', error);
          $("#loader-image").removeClass('loader-show').addClass('loader-hide');
      });
  };
  function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
  }
    
      const downloadExcel = (e) => {
        console.log(e);
        const queryString = objectToQueryString(formData);
        $("#loader-image2").removeClass('loader-hide2');
        $("#loader-image2").addClass('loader-show2');
        window.open(`${base_url}/raw-materials/listing-transports-situation-excel?${queryString}`, '_blank');
        $("#loader-image2").addClass('loader-hide2');
        $("#loader-image2").removeClass('loader-show2');
      }
  
 
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
      
  
   const handleSubmit = (e) => {

    e.preventDefault();
    console.log("formData2");
    console.log(formData);

    axios.post(
      "/raw-materials/listing-transports-new",
      formData,
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        params: formData, // Use `params` for GET request data
      }
    )
    .then((response) => {
      setDatacount(response.data.data.overview);
      setDataa(response.data.data.transports);
      setPaymentslists(response.data.data.payments);
    })
    .catch((error) => {
      console.log(error);
    });

  
  
   }
   const customHandleInput = (event) => {
     const Input_name = event.target.name;
       console.log(Input_name);   
   };

   const [showmodel, setshowmodel] = useState(false);

  const addForm = () => {
    console.log('add');
    setshowmodel(true);
  };

  const handleClose = () => {
    setshowmodel(false);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Transport Situation</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">Transport Situation Listing</li>
                  </ul>
                </div>
               
              </div>
            </div>
            <div id="filter_inputs_div" className="card filter-card1">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Driver:</label>
                   
                        <Select
                          options={trasnportList}
                          name="name"
                          value={trasnportList.find(option => option.value === formData.name) || null} // Ensure it selects the correct option
                          onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                         
                                      
                                      />
                    </div>
                  </div>        
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Start Date:</label>

                      <input type="hidden" name="supplier" className="form-control"  value={formData.transport}   />

                      <input type="date" name="start_date" className="form-control"  value={formData.start_date} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>End Date:</label>
                      <input type="date" name="end_date" className="form-control"  value={formData.end_date} onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}  />
                    </div>
                  </div>
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/transport-situation" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>
                    </div>
                  </div>
                  <div className="col-md-3 mt-3">
                      <button  onClick={() => addForm()} className="btn btn-primary">
                        <i className="fas fa-plus"></i>
                      </button>
                  </div>
                </div>
                </form>
                
              </div>
              </div>
     
            <div className="row">
                
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Total Transport  Cost </div>
                        <div className="dash-counts">
                          <p>{datacount.tab_total_amount}dh</p>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Total Payment</div>
                        <div className="dash-counts">
                        <p>{datacount.tab_paid_amount}dh</p>
                        </div>
                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                <div className="card inovices-card w-100">
                  <div className="card-body">
                    <div className="dash-widget-header">
                      <div className="dash-count">
                        <div className="dash-title"> Open Amount</div>
                        <div className="dash-counts"> <p>{datacount.tab_open_amount}dh</p>
                        </div>

                      </div>
                    </div>
                  
                  </div>
                </div>
              </div>
                    
              </div>
           
          
            <div className="row">
               <div className="col-sm-12" >
              <section className="comp-section">
              
              <div className="row">
              <div className="col-md-12">
                {permission?.list == 1 && (
              <div className="col-auto" style={{float:'right', paddingBottom:'30px'}}>
                      <button
                        className="btn btn-primary"
                        onClick={() => downloadPDF()}
                      >
                        <i className="fas fa-file-pdf font-24" ></i>  <img id="loader-image" className="loader-image loader-hide" src={loader_image}/> 
                      </button>  
                      &nbsp;&nbsp;
                      <button 
                        className="btn btn-primary"
                        onClick={() => downloadExcel()}
                      >
                        <i className="fas fa-file-excel	font-24"></i> <img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                      </button>   
              </div>
                )}
              </div>
              <div className="col-md-12">
                    {permission?.list == 1 && (
                         <div className="card bg-white">
                                                 
                            <div className="card-body">
                                <ul className="nav nav-tabs nav-tabs-bottom">
                                
                              
                                <li className="nav-item">
                                    <a className="nav-link active" href="#listing-groupby-transport" data-bs-toggle="tab">Group By Driver</a>                                  
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Raw Material Driver</a>                                   
                                </li>  
                                                  
                                </ul>
                                <div className="tab-content">
                              
                                <div className="tab-pane show active" id="listing-groupby-transport">
                                <div className="row"   id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                          <div className="table-responsive">

                                          <MaterialReactTable columns={columnss} data={dataa} 
                                            enableColumnOrdering
                                            enableColumnFilterModes
                                            enablePinning
                                          />
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                  
                                  </div>                                
                                  <div className="tab-pane  " id="listing-all">
                                    <div className="row"   id="listing-followup">
                                      <div className="col-sm-12">
                                        <div className="card card-table">
                                          <div className="card-body">
                                              <div className="table-responsive">
                                              <MaterialReactTable columns={columnspayments} data={paymentslists} 
                                                    enableColumnFilterModes
                                                    enableColumnOrdering
                                                    // enableGrouping
                                                    enablePinning
                                                  
                                                  />
                                              
                                              </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  
                                  </div>                                
                                                        
                                
                                </div>                             
                            </div>
                            </div>
                       )}
                    </div>
                    </div>
                </section>
              </div>

            </div>
          </div>
{showmodel && (
        <AddNewDriverPayment show={showmodel} handleClose={handleClose} />
      )}
        </div>
      </div>
    </>
  );
};


export default SoldesTransports;
